export const environment = {
    production: true,
    hmr       : false,

    serverUrl: 'https://api.crm.stage.investtb.by',
    serverStorageUrl: 'https://api.crm.stage.investtb.by',
    soketHost: 'https://api.crm.stage.investtb.by',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts